import angular from 'angular';

module.exports = angular.module('market.models.lead', [])
.factory('Lead', function($resource) {
  return $resource('/api/v1/leads/:id/:path', { id: '@token' }, {
    track: {
      method: 'GET',
      url: '/track'
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/lead.js
 **/